import { render } from "./MessageFeedBack.vue?vue&type=template&id=e79efaca&scoped=true"
import script from "./MessageFeedBack.vue?vue&type=script&lang=js"
export * from "./MessageFeedBack.vue?vue&type=script&lang=js"

import "./MessageFeedBack.vue?vue&type=style&index=0&id=e79efaca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e79efaca"]])

export default __exports__